export const PUBLICATION_FORM_TITLE_CONSTS = {
  errorUpdatingTheHeader: 'Ошибка при обновлении заголовка',
  titleIsTooLong: 'Слишком длинный заголовок',
  writeTextFirst: 'Сначала напишите текст'
}
